export enum ArticleCategory {
  TREATMENTS = 'treatments',
  TRENDS = 'trends',
  TECHNIQUES = 'techniques',
  INDUSTRY_NEWS = 'industry_news',
  PROVIDER_SPOTLIGHT = 'provider_spotlight',
  EDUCATION = 'education',
}

export enum TreatmentCategory {
  DERMA_FILLERS = 'derma_fillers',
  BIOSTIMULATORS = 'biostimulators',
  MICRONEEDLING = 'microneedling',
  CHEMICAL_PEELS = 'chemical_peels',
  PRP_THERAPY = 'prp_therapy',
  LASER_RESURFACING = 'laser_resurfacing',
  IPL = 'ipl',
  LASER_HAIR_REMOVAL = 'laser_hair_removal',
}

export interface Article {
  id: number;
  title: string;
  slug: string;
  content?: string;
  excerpt?: string;
  category: ArticleCategory;
  treatment_categories: TreatmentCategory[];
  tags: string[];
  featured_image_url?: string;
  author_username: string;
  author_profile_image_url?: string;
  view_count: number;
  is_popular: boolean;
  trending_score: number;
  published_at: string;
  created_at: string;
}

export interface ArticleList {
  id: number;
  title: string;
  slug: string;
  excerpt?: string;
  category: ArticleCategory;
  treatment_categories: TreatmentCategory[];
  featured_image_url?: string;
  author_username: string;
  published_at?: string;
}

export interface PopularArticle {
  id: number;
  title: string;
  excerpt: string;
  featured_image_url?: string;
  published_at: string;
  view_count: number;
  trending_score: number;
}

export interface TreatmentCategoryFilter {
  category: TreatmentCategory;
  display_name: string;
  count: number;
}

export interface WhatsHotResponse {
  popular_articles: PopularArticle[];
  recent_articles: PopularArticle[];
  treatment_filters: TreatmentCategoryFilter[];
}
